import React from 'react';
import { getApiUrl } from '../../utils/api';

/* LOT 42 · KB9 · une limite d'erreur par module : jamais de page blanche, jamais d'anglais ; l'erreur part au journal technique */
export class LimiteErreur extends React.Component {
  constructor(p) { super(p); this.state = { err: false }; }
  static getDerivedStateFromError() { return { err: true }; }
  componentDidCatch(e, info) {
    try { fetch(`${getApiUrl()}/journal-technique`, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ page: window.location.pathname, message: String(e?.message || e).slice(0, 500), pile: String(info?.componentStack || '').slice(0, 1500) }) }); } catch { /* journal indisponible */ }
  }
  componentDidUpdate(prev) { if (prev.cle !== this.props.cle && this.state.err) this.setState({ err: false }); }
  render() {
    if (!this.state.err) return this.props.children;
    return <div className="le42" role="alert" data-testid="limite-erreur"><b>Cet écran n’a pas pu s’afficher.</b><small>Le reste de l’app fonctionne. L’incident est noté, l’équipe 360 le corrige.</small><button type="button" className="m360-btn is-main" onClick={() => window.location.reload()} data-testid="limite-erreur-recharger">Recharger l’écran</button></div>;
  }
}
